import React, { useState, useContext } from "react";
import { IconButton, Stack, Box, Tooltip } from "@mui/material";
import { useMutation } from "@apollo/client";
//Icons
import { MdDelete } from "react-icons/md";
import CreateIcon from "@mui/icons-material/Create";

//Srcs
import "../../Style/actionStyle.scss";
import { AuthContext } from "../../Context/AuthContext";
import { translateLauguage } from "../../Function/Translate";

import AcademicYearForm from "./AcademicYearForm";
import DeleteForm from "../Include/DeleteForm";

import { DELETE_ACADEMIC_YEAR } from "../../Schema/AcademicYear";

export default function AcademicYearAction({ editData, setRefetch }) {
  // ===================== Change Language ==========================
  const { language, setAlert } = useContext(AuthContext);
  const { t } = translateLauguage(language);

  const [loading, setLoading] = useState(false);

  //Modal update
  const [openEdit, setOpenEdit] = useState(false);
  const handleOpenEdit = () => setOpenEdit(true);
  const handleCloseEdit = () => setOpenEdit(false);

  //Modal update
  const [openDel, setOpenDel] = useState(false);
  const handleOpenDel = () => setOpenDel(true);
  const handleCloseDel = () => setOpenDel(false);

  //======================== Create User =========================
  const [deleteAcademicYear] = useMutation(DELETE_ACADEMIC_YEAR, {
    onCompleted: ({ deleteAcademicYear }) => {
      setLoading(false);
      if (deleteAcademicYear?.is_success === true) {
        setAlert(true, "success", deleteAcademicYear?.message);
        handleCloseDel();
        setRefetch();
      } else {
        setAlert(true, "error", deleteAcademicYear?.message);
      }
    },
    onError: (error) => {
      setLoading(false);
      setAlert(true, "error", error?.message);
    },
  });

  const handleDelete = () => {
    deleteAcademicYear({
      variables: {
        id: editData?._id,
      },
    });
  };

  return (
    <div>
      <Stack direction="row" justifyContent="right">
        <Tooltip title={t("tooltip-update")} placement="top">
          <IconButton onClick={handleOpenEdit}>
            <Box className="update-container">
              <CreateIcon className="update-icon" />
            </Box>
          </IconButton>
        </Tooltip>
        <Tooltip title={t("tooltip-delete")} placement="top">
          <IconButton onClick={handleOpenDel}>
            <Box className="delete-container">
              <MdDelete className="delete-icon" />
            </Box>
          </IconButton>
        </Tooltip>
      </Stack>

      <AcademicYearForm
        dialogTitle="Update"
        open={openEdit}
        handleClose={handleCloseEdit}
        editData={editData}
        setRefetch={setRefetch}
      />
      <DeleteForm
        open={openDel}
        handleClose={handleCloseDel}
        title="dialog_title_delete_academic_year"
        confirmVal="Academic-Year"
        handleDelete={handleDelete}
      />
    </div>
  );
}
